import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ActionButtons from '../ActionButtons/ActionButtons';
import Button from '../Button/Button'

const dialogStyle = {
	zIndex: '1302'
}

export default class FormDialog extends React.Component {
	state = {
		open: false,
	};

	handleClickOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	render() {
		const { open, title, contentText, submit, cancel, submitText, cancelText, type = 'confirm' } = this.props;
		let dialogActions = ''
		switch (type) {
			case 'confirm':
				dialogActions = <ActionButtons
					submit={submit}
					cancel={cancel}
					submitText={submitText}
					cancelText={cancelText}
				/>
				break;
			case 'alert':
				dialogActions = <Button
					onClick={cancel}
				>OK</Button>
				break;
			default:
				break;
		}

		return (
			<Dialog
				open={open}
				onClose={this.handleClose}
				aria-labelledby="form-dialog-title"
				style={dialogStyle}
			>
				<DialogTitle id="form-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{contentText}
					</DialogContentText>
					{this.props.children}
				</DialogContent>
				<DialogActions>
					{dialogActions}
				</DialogActions>
			</Dialog>
		);
	}
}
